import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ISubscription, Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Rx';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService, DBService, DownLoadService } from '../../service';
import { Result, Table, outputGraph } from '../../model/small-molecule.model';
import { AnalysisDetails, DownloadFile, NewTable, SearchResult } from '../../model/analysis-details.model';
// import { NgxXml2jsonService } from 'ngx-xml2json';
import { SharedService } from '../../layouts/shared-service';
import { User } from '../../model/types';
import { DropDownService } from '../../service/drop-down.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
// import { GraphDialogComponent } from './graph-dialog/graph-dialog.component';
import { AppLoaderService } from '../../service/app-loader/app-loader.service';
import { interval } from 'rxjs/internal/observable/interval';
import { error } from 'console';
import { bool } from 'aws-sdk/clients/signer';
import { AuthNewService } from '../../service/auth-new.service';
import { delay } from 'rxjs/operators';
import { StorageService } from '../../service/storage.service';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { environment } from '../../../environments/environment';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import jsPDF from 'jspdf';
const htmlToPdfmake = require("html-to-pdfmake");
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
    selector: 'app-small-molecule',
    templateUrl: './small-molecule.component.html',
    styleUrls: ['./small-molecule.component.scss']
})
export class SmallMoleculeComponent implements OnInit, OnDestroy {

    pageTitle = 'Analyze Report/Data';
    signedInUser: any;
    analysisId = '';
    searchResult: SearchResult = <SearchResult>{};
    // analysisResponseNew: SearchResult = <SearchResult>{};
    selectedTables: string;
    analysisDetails: AnalysisDetails;
    public tables: Table[] = [];
    tablesKey: any = [];
    tablesValue: any = [];
    stattablesKey: any = [];
    stattablesValue: any = [];
    tablesList: NewTable[];
    tablesNotFound: any = [];
    tableData: any;
    tableAnalysisType: string;
    routersub: ISubscription;
    callerSubscription: Subscription;
    tableSelected = false;
    tableProcessed = false;
    reviewTableSelection = false;
    public results: Result[];
    tempData: any;
    title = 'Loading';
    mysubscription: any;
    visibleData = 0;
    public showcharts = false;
    item;
    output_graph: outputGraph[];
    graphs: any[] = [];
    private singleSearchData: Subscription;
    private currentLoginUser: Subscription;
    private PostEventData: Subscription;
    private getEventData: Subscription;
    // public Histograms = [];
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild('htmlData', { static: false }) htmlData!: ElementRef;
    @ViewChild('auditData', { static: false }) auditData!: ElementRef;
    AuditPdfData;
    ParsedPdfData;
    EventDataUrl: string = environment.serverUrl + '/event-data';
    DownloadFileobject: DownloadFile = <DownloadFile>{};
    // @ViewChild('textData') data: ElementRef;
    logo = 'data:image/jpg;base64,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'


    step = 0;
    updateOptions: Object;
    data: any;
    options: {};
    navigationSubscription: Subscription;
    usr: any;
    formType: any;
    currentUser: User;
    illegalUser: boolean;
    sData: SearchResult;
    checked: boolean = false;
    disabled: boolean = false;
    displayTable: boolean = false;
    isFetching: boolean = true;
    displayPDFData: boolean = true;
    displayExPanels: boolean = true;
    searchResultData: boolean = true;
    errortable: any;
    extractrunid = [];
    columnArray = [];
    dataArray = [];
    jsonDataArray = [];
    displayObservation: boolean = false;
    signedInUserAccess;
    output_path:string;

    constructor(private _sharedService: SharedService,
        private activatedroute: ActivatedRoute,
        private authService: AuthService,
        private AuthService: AuthNewService,
        private elRef: ElementRef,
        private router: Router,
        private http: HttpClient,
        private ngxXml2jsonService: NgxXml2jsonService,
        private dbService: DBService,
        private dropDownService: DropDownService,
        private downloadService: DownLoadService,
        public dialog: MatDialog,
        // private ngxXml2jsonService: NgxXml2jsonService,
        private ref: ChangeDetectorRef,
        private loader: AppLoaderService,
        private storageService:StorageService,
        public datepipe: DatePipe) {
        this._sharedService.emitChange(this.pageTitle);
        // if(this.tables.length==0){
        //     this.openDialog()
        // }


        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd) {
                this.initialiseInvites();
            }
        });




    }


    initialiseInvites() {
        this.authService.getCurrentUser((err, user: User) => {
            this.currentUser = user;
            this.activatedroute.paramMap.subscribe((params) => {
                if (params.get('user') !== this.currentUser.username) {
                    return
                } else {
                    this.usr = params.get('user');
                    this.analysisId = params.get('id');
                }

            });
        });

    }

    ngOnInit() {
        this.pollForResult();

        this.dbService.singleSearch.subscribe(
            (data: SearchResult) => {


                if (Object.keys(data).length === 0) {
                    this.searchResultData = false;
                } else {
                    this.isFetching = false;
                }

                data && this.populateResultData(data);
            }
        );
        this.storageService.remove('xyz');

    }

    ToggleState(event) {
        this.displayTable = !this.displayTable;
   
    }
    ToggleState2(event) {
        this.displayObservation = !this.displayObservation;
    }

    ToggleState1(event) {
        this.displayPDFData = !this.displayPDFData;
        this.displayExPanels = !this.displayExPanels;
        this.displayTable = false;
    }

    openDialog() {
        this.loader.open(this.title);

    }

    closeDialog() {
       
        this.loader.close();
    }

    // ngAfterViewInit() {
    //     let li = this.data.nativeElement.value;
    
    // }
    showCharts() {
        this.showcharts = true;
    }

    xmlToObj(xmlString: string) {
        const parser = new DOMParser();
        const xml = parser.parseFromString(xmlString, 'text/xml');
        const obj = this.ngxXml2jsonService.xmlToJson(xml);
        this.tables = JSON.parse(JSON.stringify(obj))['Tables']['Table'];
        // if(this.tables.length){
        //     this.closeDialog()
        //   }
        // console.log('TABLE DATA ')
        // console.log(!this.tables.length);
        if (!this.tables.length) {
            // console.log('SPECIAL CASE');
            const table = {
                analyte_name: this.tables['analyte_name'],
                table_type: this.tables['table_type'],
                table_index: this.tables['table_index'],
                table_title: this.tables['table_title'],
                analysis_type: this.tables['analysis_type'],
                rows: this.tables['rows'],
                valid: this.tables['valid'],
                tb_title: this.tables['tb_title'],
                table_subtype: this.tables['table_subtype']
            };
            // console.log('table data', table);
            this.tables = [];
            this.tables.push(table)
        }
        // console.log('this.tables length ', this.tables.length);
        // console.log('this.tables ', this.tables);
    }

    pollForResult() {
        // tslint:disable-next-line: max-line-length
        // if(this.searchResult.analysisStatus === 'TableResult' || this.searchResult.analysisStatus === 'Complete' || this.searchResult.analysisStatus === 'Error'){
        //     this.closeDialog();
        // }
        // const callInterval = interval(10000);
        this.authService.getCurrentUser((err, user: User) => {
            this.signedInUser = user;
            if (!this.signedInUser || !this.signedInUser.signedIn) {
                this.router.navigate(['/extra-layout/signin']);
                return;
            } else {
                this.signedInUserAccess =  this.storageService.get('access')
                this.activatedroute.paramMap.subscribe((params) => {
                    if (this.signedInUserAccess == 'SU' || this.signedInUserAccess == 'GA' || this.signedInUserAccess == 'QA' || this.signedInUserAccess == 'PI') {

                        this.usr = params.get('user');
                        this.analysisId = params.get('id');
                        this.dbService.getAnalysisDetails(this.usr, this.analysisId);
                        this.illegalUser = false;
                    }

                });
//                 if (!this.illegalUser) {
//                     // this.callerSubscription = callInterval.subscribe(() => {
//                     //     const status = this.searchResult?.analysisStatus;
//                     //
//                     //     if ((status === 'TableResult' || status === 'Complete' || status === 'Error')) {
//                     //         this.callerSubscription.unsubscribe();
//                     //     } else {
//                     this.dbService.getAnalysisDetails(this.signedInUser.username, this.analysisId);
//                     //     }
//                     // })
//                 }
            }
        });
        this.ref.detectChanges();





    }



    setStep(index: number) {
        this.step = index;

    }

    nextStep(table: Table, selection: boolean) {
        table.valid = selection;
        this.step++;

        for (const obj of this.tables) {
            if (obj.valid === true || obj.valid === false) {
                this.tableSelected = true;
            } else {
                this.tableSelected = false;
                break;
            }
        }
    }

    submitTableData() {
        this.tableProcessed = true;
        this.reviewTableSelection = false;
        this.dbService.submitTableData(this.tables, this.signedInUser.username, this.analysisId).subscribe((data: Result[]) => {
            this.pollForResult();
        });
    }

    getCount(result: Result, color: string) {
        let count = 0
        for (const resultItem of result.resultItem) {
            for (const items of resultItem.item) {
                if (items.color === color) {
                    count = count + items.message.length
                }
            }
        }
        return count;
    }

    getColor(level: string): string {
        if (level === 'Green') {
            return '#C5EEB2'
        } else if (level === 'Yellow') {
            return '#F8F8A9'
        } else if (level === 'Info') {
            return '#75cff8'
        } else if (level === 'Red') {
            return '#EEC2B7'
        }
    }


    processResult() {

        for (const result of this.results) {
            for (const resultItem of result.resultItem) {
                for (const item of resultItem.item) {
                    item.colorCode = this.getColor(item.color);
                }
            }
        }
        this.formType = this.searchResult.analysisType;
        // console.log("actual link", this.searchResult.analysisResultFile);
//         const output_file = this.getSignedURL(this.searchResult.analysisResultFile);
//         this.searchResult.analysisResultFile = output_file
        const output_data = this.getSignedURL(this.searchResult.analysisResultData);
        this.output_path = output_data;
//         console.log(this.searchResult);
        if (this.searchResult.ParsedDataPath) {
//             console.log(this.searchResult.ParsedDataPath);
            this.downloadService.getS3Obj(this.searchResult.ParsedDataPath).then(
                data => {
//                     console.log(data.trim().split(/\n/));
                    this.ParsedPdfData = data.trim().split(/\n/).map((line) => JSON.parse(line));
//                     console.log(this.ParsedPdfData);
                }
            );
        }
//         const output_file2 = this.getSignedURL(this.searchResult.AnalysisResultXlsxFile);
//         this.searchResult.AnalysisResultXlsxFile = output_file2;
//         try {
//             this.output_graph = JSON.parse(this.searchResult.AnalysisResultGraph);
//         } catch (error) {
//         }
    }
    findKey(table) {
        //    this.arraytoJson(table)
        return table.hasOwnProperty('error')
    }

    
    populateResultData(data: SearchResult) {
//         this.tablesList = [];
        this.searchResult = data;
//         this.tableAnalysisType = this.searchResult.analysisSubtype;
//         this.tablesList = this.searchResult.Tables;
//         this.tablesNotFound = this.searchResult.MissingTables;
        const status = this.searchResult.analysisStatus;
        // TableSelected, NewAnalysis, Complete
//         if (this.searchResult.analysisStatus === 'TableSelected' || this.searchResult.analysisStatus === 'Processed') {
//             this.openDialog()
//         }
//         if (this.searchResult.analysisStatus === 'Complete' || this.searchResult.analysisStatus === 'Error') {
//             this.closeDialog()
//         }

//         this.analysisDetails = JSON.parse(this.searchResult?.analysisDetails);
        if (status === 'TableResult') {

            if ((this.searchResult.Tables?.length > 4)) {

            }

        } else if (status === 'TableSelected') {
            this.selectedTables = this.searchResult.selectedTables;
            this.pollForResult()
        } else if (status === 'Complete' || status === 'Validation Complete') {
//             if ((this.searchResult.Tables.length > 4)) {
//                 this.xmlToObj(this.searchResult.tableData);
//             }
            this.results = JSON.parse(this.searchResult.analysisResult);
            const eventName = 'View';
            this.DownloadFileobject.userId = this.storageService.get('username');
            this.DownloadFileobject.eventName = eventName;
            this.DownloadFileobject.analysisId = this.analysisId;
            this.DownloadFileobject.analysisType = 'Regression';
            this.DownloadFileobject.userName = this.storageService.get('name');
            this.DownloadFileobject.filePath = this.searchResult?.audit_file_path;
            this.DownloadFileobject.userRole = this.storageService.get('access');

            let params = new HttpParams();
            params = params.append('analysisId', this.analysisId);

            this.PostEventData = this.http.post(this.EventDataUrl, this.DownloadFileobject).subscribe(
                (response) => {

                    this.getEventData = this.http.get(this.EventDataUrl, { params: params }).subscribe(
                        (res) => {
                            this.AuditPdfData = res;
                        }
                    )
                },
                (error) => {
                    console.error('API call error:', error);
                }
            );

            this.processResult();

        } else if (status === 'Error') {
          
        }
    }


    tableFlag(text: string) {
        const flag = text.startsWith('<table') || text.startsWith('graph');
        return flag

    }

    getDisplayString(key) {
        return this.dropDownService.nameDescMap.get(key);
    }

    getSignedURL(path: string) {
        if (path.indexOf('https') !== -1) {
            return path;
        } else if (/\S/.test(path)) {
            return this.downloadService.getUrl(path, false);
        } else {
            return ' ';
        }

    }

    getOutputFilePath() {
    //  TODO: Refactor this into a service/method
        const eventName = 'Download';
        this.DownloadFileobject.userId = this.storageService.get('username');
        this.DownloadFileobject.eventName = eventName;
        this.DownloadFileobject.analysisId = this.analysisId;
        this.DownloadFileobject.analysisType = 'Regression';
        this.DownloadFileobject.userName = this.storageService.get('name');
        this.DownloadFileobject.filePath = this.searchResult?.audit_file_path;
        this.DownloadFileobject.userRole = this.storageService.get('access');

        let params = new HttpParams();
        params = params.append('analysisId', this.analysisId);

        this.PostEventData = this.http.post(this.EventDataUrl, this.DownloadFileobject).subscribe(
            (response) => {

                this.getEventData = this.http.get(this.EventDataUrl, { params: params }).subscribe(
                    (res) => {
                        this.AuditPdfData = res;

                    }
                )
            },
            (error) => {
                console.error('API call error:', error);
            }
        );
        return this.output_path;
    }

    review() {
        const tableObjects: Table[] = JSON.parse(this.searchResult.selectedTables);
        const table_indexes: string[] = new Array();
        for (const tab of tableObjects) {
            table_indexes.push(tab.table_index)
        }

        for (const table of this.tables) {
            if (table_indexes.includes(table.table_index)) {
                table.valid = true;
            } else {
                table.valid = false;
            }
        }

        this.reviewTableSelection = true;
    }

    openGraph() {
        this.output_graph.forEach((element) => {
            const link = this.getSignedURL(element.key);
            const title = element.title;
            this.graphs.push(link);
        })
        // this.dialog.open(GraphDialogComponent, { data: { name: this.graphs }, disableClose: false, height: '540px', width: '82%' });

    }
    ngOnDestroy(): void {
        if (this.callerSubscription) {
            this.callerSubscription.unsubscribe();
        }
        if (this.mysubscription) {
            this.mysubscription.unsubscribe();
        }

        if (this.singleSearchData) {
            this.singleSearchData.unsubscribe();
        }
        if (this.currentLoginUser) {
            this.currentLoginUser.unsubscribe();
        }
        if (this.getEventData) {
            this.getEventData.unsubscribe();
        }
        if (this.PostEventData) {
            this.PostEventData.unsubscribe();
        }


    }

    exportAuditPDF() {
        let maxDate = new Date();
        const maxAuditUTCDate = this.datepipe.transform((maxDate), 'yyyy-MM-dd HH:mm:ss', 'UTC');
        const doc = new jsPDF();
        const pdfTable = this.auditData?.nativeElement;
        let html = htmlToPdfmake(pdfTable.innerHTML);
        const documentDefinition = {
            content: [
                {
                    image: this.logo,
                    width: 150,
                    style: 'logo',
                    margin: [0, 10, 10, 10],
                    fontSize: 10,
                },
                {
                    text: maxAuditUTCDate,
                    width: 35,
                    style: 'date',
                    fontSize: 10,
                },
                {
                    text: [{ text: 'Project Code: ', bold: true }, this.searchResult.projectCode],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 20, 10, 0],
                    fontSize: 10,
                },
                {
                    text:  [{ text: 'Analyte Name: ', bold: true }, this.searchResult.analyteNames[0]],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'RedThread User ID: ', bold: true }, this.searchResult.userId],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text:  [{ text: 'RedThread Analysis Date(UTC): ' , bold: true },this.searchResult.analysisDate],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: ("AUDIT REPORT"),
                    width: 100,
                    bold: true,
                    alignment: 'center',
                    margin: [10, 20, 10, 10],
                    decoration: 'underline',
                    fontSize: 15,
                },
                html
            ],
            styles: {
                logo: {
                    alignment: 'left',
                },
                date: {
                    alignment: 'right',
                }
            }
        };
        pdfMake.createPdf(documentDefinition).download('RedThread Audit.pdf')
    }

    exportPDF() {
        let maxDate = new Date();
        const maxUTCDate = this.datepipe.transform((maxDate), 'yyyy-MM-dd HH:mm:ss', 'UTC');
        const doc = new jsPDF();
        const pdfTable = this.htmlData?.nativeElement;
        let html = htmlToPdfmake(pdfTable.innerHTML);

        const documentDefinition = {
            content: [
                {
                    image: this.logo,
                    width: 150,
                    style: 'logo',
                },
                {
                    text: maxUTCDate,
                    width: 35,
                    style: 'date',
                    bold: true,
                    fontSize: 10,

                },
                {
                    text: [{ text: 'Project Code: ', bold: true }, this.searchResult.projectCode],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 20, 10, 0],
                    fontSize: 10,

                },
                {
                    text:  [{ text: 'Analyte Name: ', bold: true }, this.searchResult.analyteNames[0]],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'RedThread User ID: ', bold: true }, this.searchResult.userId],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text:  [{ text: 'RedThread Analysis Date(UTC): ' , bold: true },this.searchResult.analysisDate],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: ('RedThread Parsed Input Data Report'),
                    width: 100,
                    bold: true,
                    alignment: 'center',
                    margin: [10, 20, 10, 10],
                    decoration: 'underline',
                    fontSize: 15,
                },
                html

            ],
            styles: {
                logo: {
                    alignment: 'left',
                },
                date: {
                    alignment: 'right'
                }
            }
        };
        pdfMake.createPdf(documentDefinition).download('RedThread Parsed Input Report.pdf');
    }

}
